module.exports = __webpack_public_path__ + "img/img_series_113.e3ffdd6c.png";